import React from 'react';
import {Form, Select} from "antd";
import {useSelector} from "react-redux";
import {useGetDevicesQuery} from "../slices/rootApiSlices/deviceApiSlice";

const SearchDevice = ({onChange}) => {

    const {user} = useSelector((state) => state.auth);
    const {data, error, isLoading} = useGetDevicesQuery(user?.token);

    if (isLoading) {
        return (
            <div style={{display: 'flex', alignItems: 'center' , justifyContent: 'center'}}>yükleniyor</div>
        )
    }

    if (error) {
        return (
            <div>hata lütfen bekleyiniz</div>
        )
    }


    const onSearch = (value) => {
        console.log('search:', value);
    };


    return (
        <Form.Item
            name="device_id"
            rules={[{
                required: true,
                message: 'lütfen cihaz seçiniz !'
            }]}
            style={{width: 'calc(100% - 2px)'}}
        >
            <Select
                allowClear
                showSearch
                placeholder="Cihaz seçiniz"
                optionFilterProp="children"
                onChange={onChange}
                loading={isLoading}
                onSearch={onSearch}
                filterOption={(input, option) =>
                    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                }
                options={data !== null ? data?.map((item) => {
                    return {
                        value: item.device_id,
                        label: item.device_id
                    }
                }) : null}
            />
        </Form.Item>
    );
};

export default SearchDevice;
